import { Notification } from './notification';

const notification = new Notification();

export { notification };
